/**
 *    SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => {
  const { type } = theme.palette;
  const dark = type === 'dark';
  return {
    fullwidth: {
      width: '100%',
      marginTop: 120,
      minHeight: window.innerHeight - 205,
      backgroundColor: '#F9F9F9',
    },
    display: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '84%',
      backgroundColor: dark ? 'transparent' : undefined,
    },
    card: {
      color: dark ? '#ffffff' : undefined,
      backgroundColor: dark ? '#453e68' : undefined,
    },
  };
};

export const View = ({ children, classes }) => (
  <div className={classes.fullwidth}>
    <div className={classes.display}>
      {children}
    </div>
  </div>
);

export default withStyles(styles)(View);
